import React from 'react';
import { useSelector } from 'react-redux';

import { PageSection } from 'common/styles/page';
import DashboardPillarScores from 'areas/dashboard/components/DashboardPillarScores';
import DashboardCard from 'areas/dashboard/components/DashboardCard';
import OrganizationalInsights from './OrganizationalInsights';

import styled from 'styled-components';
import { getSelectedAssessmentPeriodId } from 'common/selectors/auth';

const OrgGoalsHeader = () => {
  const assessmentPeriodId = useSelector(getSelectedAssessmentPeriodId);

  return (
        <DashboardCard>
      <PageSection display='flex' flexDirection='row' flex='2'>
          <Half>
            <OrganizationalInsights />
          </Half>
          <Divider />
          <Half>
            <DashboardPillarScores assessment_period_id={assessmentPeriodId} />
          </Half>
    </PageSection>
        </DashboardCard>
  );
};
export default OrgGoalsHeader;


const Half = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  align-items: stretch;
  padding: 0;
`;

const Divider = styled.div`
  width: 1px;
  background: #e5e7eb; /* light grey */
  margin: 0 40px; 
  align-self: stretch;
`;
